import React from 'react';
import {
  useNavigate as useRouterNavigate,
  To,
  useLocation,
  useParams,
} from './platform_router';
export * from './platform_router';

export function useNavigate() {
  const navigate = useRouterNavigate();
  const location = useLocation();

  return (dest: To | number, opts?: any) => {
    if (typeof dest === 'number') {
      if (location?.state?.prev_url) {
        navigate(dest);
      } else {
        navigate('/', { replace: true });
      }
    } else {
      if (!opts) {
        opts = {};
      }
      if (!opts.state) {
        opts.state = {};
      }
      opts.state.prev_url = location?.pathname;
      navigate(dest, opts);
    }
  };
}
export function useHashKey(...args: string[]): string | string[] {
  const location = useLocation();
  const values: string[] = [];
  const hash = location?.hash;
  if (hash) {
    const hash_s = hash.slice(1);
    const map: any = {};

    hash_s.split('&').forEach((part) => {
      const k_v = part.split('=');
      if (k_v.length === 2) {
        map[k_v[0]] = k_v[1];
      }
    });
    for (let i = 0; i < args.length; i++) {
      values[i] = map[args[i]];
    }
  }
  return values;
}
export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useRouterNavigate();
    const params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
        match={{ params }}
      />
    );
  }
  return ComponentWithRouterProp;
}
